import { render } from "./EnTabView.vue?vue&type=template&id=5b0ee642&scoped=true"
import script from "./EnTabView.vue?vue&type=script&setup=true&lang=js"
export * from "./EnTabView.vue?vue&type=script&setup=true&lang=js"

import "./EnTabView.vue?vue&type=style&index=0&id=5b0ee642&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0ee642"],['__file',"Shared/components/tabs/EnTabView/EnTabView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b0ee642"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b0ee642', __exports__)) {
    api.reload('5b0ee642', __exports__)
  }
  
  module.hot.accept("./EnTabView.vue?vue&type=template&id=5b0ee642&scoped=true", () => {
    api.rerender('5b0ee642', render)
  })

}


export default __exports__